import styled from '@emotion/styled';
import React, { useEffect, useState } from 'react';
import { FlexWrapper } from '../../theme/common_style';
import { Divider, Skeleton } from 'antd';
import { GetLeaveCredits } from '../../redux/lms/apiRoute';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import EmployeeLeavesTable from './EmployeeLeavesTable';

function getFinancialYearRange(date = dayjs()) {
  const currentYear = date.year();
  const currentMonth = date.month(); // 0-indexed (0 = Jan, 3 = Apr)

  const startYear = currentMonth >= 3 ? currentYear : currentYear - 1;
  const endYear = startYear + 1;

  return `Apr ${startYear} - Mar ${endYear}`;
}

const Section = ({ title, data }) => {
  return (
    <FlexWrapper direction={'column'} justify={'start'} align={'flex-start'}>
      <p className="title">{title}</p>
      <p className="para">{data}</p>
    </FlexWrapper>
  );
};

Section.propTypes = {
  title: PropTypes.string,
  data: PropTypes.any
};

const EmployeeLeaves = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const [leaveInfo, setLeaveInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const { isEmployee } = useSelector((e) => e.userInfo);

  const handleListing = async () => {
    setLoading(true);
    let res = await GetLeaveCredits(id);
    if (res?.statusCode === 200) {
      setLeaveInfo(res?.data);
    } else {
      toast.error(res?.message || 'Something went wrong');
    }
    setLoading(false);
  };

  useEffect(() => {
    handleListing();
  }, [id]);

  return (
    <>
      <InfoStyle>
        <FlexWrapper justify={'start'} align={'center'}>
          <h2>Leave Summary</h2>
        </FlexWrapper>
        <Divider style={{ margin: '0' }} />
        <GrayBox>
          <GridBox cols={4}>
            {loading ? (
              <>
                {Array.from({ length: 4 }).map((_, key) => (
                  <Skeleton.Input active key={key} />
                ))}
              </>
            ) : (
              <>
                <Section title={'Year'} data={getFinancialYearRange()} />
                <Section title={'Assignee Leaves'} data={leaveInfo?.assigneeLeaves || 0} />
                <Section title={'Consume'} data={leaveInfo?.consume || 0} />
                <Section title={'Balance'} data={leaveInfo?.balance || 0} />
              </>
            )}
          </GridBox>
        </GrayBox>
      </InfoStyle>
      {!isEmployee && <EmployeeLeavesTable />}
    </>
  );
};

export default EmployeeLeaves;

const GrayBox = styled.div`
  background: #f2f3f8;
  padding: 16px;
  border-radius: 12px;
  margin-top: 16px;
`;
export const GridBox = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ cols }) => `repeat(${cols}, 1fr)`};
  gap: ${({ gap }) => gap || '16px'};
  @media (max-width: 868px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 668px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
const InfoStyle = styled.div`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  border-radius: 12px;
  padding: 16px 16px 24px;
  margin-top: 24px;

  h2 {
    font-family: Plus Jakarta Sans;
    font-weight: 700;
    font-size: 20px;
    color: #0e0e0e;
  }

  .date {
    width: 100px;
    height: 100%;
    padding: 12px;
    background: #f1f1f1;
  }

  .title {
    font-family: Plus Jakarta Sans;
    font-weight: 400;
    font-size: 14px;
    color: #767676;
    margin: 0 !important;
  }

  .para {
    font-family: Plus Jakarta Sans;
    font-weight: 500;
    font-size: 16px;
    color: #0e0e0e;
    margin: 0 !important;
  }
`;
